<template>
    <app-primary class="app--main">
        <main-visual />

        <section>
            <v-sheet height="32">
                <v-row no-gutters justify="end" align="center" class="h-100">
                    <v-col cols="auto">
                        <txt class="txt--sm txt--dark px-12px">* 홈페이지의 이미지는 실제 조성 이미지가 아닌 이해를 돕기 위한 이미지 입니다.</txt>
                    </v-col>
                </v-row>
            </v-sheet>
        </section>

        <main-section-primary class="main-section--sm">
            <v-row align="center">
                <v-col cols="12" md="4">
                    <tit-tertiary class="font-weight-bold">
                        인생의 터닝포인트를 잡다. <br />
                        <span class="primary--text">세이지움 개봉</span>
                    </tit-tertiary>
                </v-col>
                <v-col cols="12" md="8">
                    <txt-primary class="line-height-15">
                        <div>개봉역 역세권 청년안심주택 세이지움 개봉은 지하철 1호선 개봉역 역세권에 위치해 있으며 지하철 7호선 광명사거리역과 가까운 입지로 교통 생활 편의성이 뛰어난 청년안심 주택입니다.</div>
                        <br />
                        <div>서울시 구로구 내 처음 공급되는 청년안심주택으로, 입주민 편의를 위한 피트니스, 작은 도서관, 코인세탁실 등 대규모 커뮤니티 공간을 갖추고 있어 청년들의 소중한 시간을 지켜주고 여유 있는 라이프 스타일을 즐길 수 있습니다.</div>
                    </txt-primary>
                </v-col>
            </v-row>
        </main-section-primary>

        <main-section-primary class="main-section--sm main-section--special">
            <v-row justify="space-between" align="center">
                <v-col cols="12" md="5" lg="4" xl="3">
                    <tit-wrap-primary titWrapSize="tit-wrap--sm" subTitSize="tit--xxs" subTitClass="white--text" titClass="white--text font-weight-bold">
                        <template #TitAdd>SEIZIUM GAEBONG</template>
                        개봉역 역세권<br />
                        청년안심주택<br />
                        세이지움 개봉 특장점
                    </tit-wrap-primary>
                    <txt-primary class="white--text">서울 역세권에 위치하여 가까운 교통시설 이용과 <br class="d-none d-xl-block" />편리한 생활인프라를 가지고 있습니다.</txt-primary>
                    <div class="btn-wrap justify-start">
                        <v-btn tile outlined x-large width="160" href="/business/overview" color="white" class="btn-special btn-special--01">사업안내</v-btn>
                    </div>
                </v-col>
                <v-col cols="12" md="6" data-aos="fade-left" data-aos-delay="100">
                    <div class="image-wrap">
                        <v-img eager src="/images/main/special.jpg" />
                    </div>
                </v-col>
            </v-row>
        </main-section-primary>

        <template v-for="(item, index) in items">
            <main-section-primary :key="index" class="main-section--sm main-section--list">
                <v-row align="center" class="row--xxl">
                    <v-col cols="12" md="4" :order-md="index % 2 === 0 ? '2' : null">
                        <tit-wrap-primary titWrapSize="tit-wrap--sm" subTitSize="tit--xxs" subTitClass="primary--text" titClass="font-weight-bold">
                            <template #TitAdd>PREMIUM 0{{ index + 1 }}</template>
                            <div v-html="item.title"></div>
                        </tit-wrap-primary>
                        <txt-primary>
                            <div v-html="item.text" />
                        </txt-primary>
                        <template v-if="item.link">
                            <div class="btn-wrap justify-start">
                                <v-btn tile outlined x-large width="160" :to="item.link" class="btn-special btn-special--02">더보기</v-btn>
                            </div>
                        </template>
                    </v-col>
                    <v-col cols="12" md="8" :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'" data-aos-delay="100">
                        <div class="image-wrap">
                            <v-img eager max-width="952" :src="item.image">
                                <template v-if="item.imageText">
                                    <v-sheet color="rgba(0,0,0,0.6)" width="100%" height="100%" class="d-flex justify-center align-center pa-12px">
                                        <tit class="tit--lg white--text text-center">
                                            <div v-html="item.imageText" />
                                        </tit>
                                    </v-sheet>
                                </template>
                            </v-img>
                        </div>
                    </v-col>
                </v-row>
            </main-section-primary>
        </template>

        <main-section-primary class="main-section--sm main-section--contact">
            <tit-wrap-primary titWrapSize="tit-wrap--sm" titWrapClass="text-center" subTitSize="tit--xxs" subTitClass="primary--text" titSize="tit--lg" titClass="font-weight-regular white--text" data-aos="fade-up" data-aos-delay="100">
                <template #TitAdd>CONTACT US</template>
                인생의 터닝포인트를 잡다.<br />
                개봉역 역세권 청년안심주택<br />
                세이지움 개봉
            </tit-wrap-primary>
            <div class="d-flex justify-center">
                <v-btn tile color="primary" x-large width="160" to="/application">청약 신청</v-btn>
            </div>
        </main-section-primary>
        <popup-layer />
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainSectionPrimary from "@/sets/parents/mains/main-section-primary.vue";
import MainSectionSecondary from "@/sets/parents/mains/main-section-secondary.vue";
import MainVisual from "@/sets/styles/mains/main-visual.vue";
import BtnPrimary from "@/components/publish/parents/buttons/btn-primary.vue";

import TitWrapPrimary from "@/components/publish/parents/typography/tit-wrap-primary.vue";
import TitTertiary from "@/components/publish/parents/typography/tit-tertiary.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    components: {
        AppPrimary,
        PopupLayer,
        MainSectionPrimary,
        MainSectionSecondary,
        MainVisual,
        BtnPrimary,

        TitWrapPrimary,
        TitTertiary,
        TxtPrimary,
        Tit,
        Txt,
    },
    props: {},
    data: () => ({
        items: [
            {
                title: "초역세권 교통 프리미엄",
                text: "1호선 개봉역 역세권, 7호선 광명사거리역 인접 <br class='d-md-none d-lg-block' />경인로와 서부간선도로 등 광역도로 인접",
                image: "/images/main/list-1.jpg",
                link: "/business/feature",
            },
            {
                title: "직주근접 프리미엄",
                text: "가산디지털단지, 구로디지털단지, 여의도, 목동 등 <br class='d-md-none d-lg-block' />주요 업무지구와 인접해 있어 최적의 직주근접 환경",
                image: "/images/main/list-2.jpg",
                link: "/business/feature",
            },
            {
                title: "청년, 신혼부부세대 <br />커뮤니티공간 프리미엄",
                text: "단지 내 입주민 전용 커뮤니티 시설로 편리한 생활 <br class='d-md-none d-lg-block' />대형 피트니스 및 코인세탁실, 서울시가 조망되는 <br class='d-md-none d-lg-block' />21층 작은 도서관 조성.",
                image: "/images/main/list-3.jpg",
                link: "/business/feature",
            },
            {
                title: "주변 편의시설 프리미엄",
                text: "아이파크몰, 코스트코, 광명시장 등 대형 쇼핑시설과 <br class='d-md-none d-lg-block' />목감천, 개웅산 등 쾌적한 자연환경",
                image: "/images/main/list-4.jpg",
                link: "/business/feature",
            },
            {
                title: "금융지원",
                text: "청년의 시작을 응원하며, 까다롭지 않은 기준과 조건으로 <br class='d-md-none d-lg-block' />청약신청자 여러분에게 맞춤 금융 지원을 해드립니다.",
                image: "/images/main/list-5.jpg",
                imageText: "신혼부부와 청년의 PREMIUM 특권! <br class='d-none d-sm-block' />무이자 1%대 대출 지원",
                link: "/subscription/support",
            },
        ],
    }),
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep {
    @media (min-width: 1024px) {
        #main {
            padding-top: 0 !important;
        }
    }
}
.main-section {
    background-size: cover;
    background-repeat: no-repeat;
    max-width: 1920px;
    margin: auto;
    &--special {
        background-image: url("/images/main/special-bg.jpg");
        background-position: bottom left;
    }
    &--contact {
        background-image: url("/images/main/contact-bg.jpg");
        background-position: center;
        aspect-ratio: 1920 / 960;
        max-width: 1920px;
        display: flex;
        align-items: center;
    }
}

.v-application .btn-special {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    &--01:hover {
        background-color: #fff !important;
        color: var(--v-grey-darken4) !important;
    }
    &--02:hover {
        background-color: var(--v-primary-base) !important;
        border-color: var(--v-primary-base) !important;
        color: #fff !important;
    }
}
@media (min-width: 768px) {
    .main-section {
        &--special {
            background-size: contain;
        }
        &--list {
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                width: calc(705 / 1920 * 100%);
                height: 100%;
                background-color: var(--v-grey-lighten5);
            }
            &:nth-of-type(2n) {
                &::before {
                    right: 0;
                }
            }
        }
    }
}

@media (min-width: 1600px) {
    .main-section--special {
        background-size: calc(1192 / 1920 * 100%);
    }
}
</style>
